// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/modules/products/v2_0/components/OverallScore/OverallScore.scss
// module id = 1371
// module chunks = 10 21